import { useEffect, useRef, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../auth';
import { LanguageSwitch } from './LanguageSwitch';

export function TopBar() {
  const { t } = useTranslation();
  const { user, logout } = useAuth();
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();
  const headerRef = useRef<HTMLElement>(null);

  // Ohne das bliebe das Panel nach jedem Tippen auf einen Link offen stehen.
  useEffect(() => setOpen(false), [pathname]);

  useEffect(() => {
    if (!open) return;
    const onKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setOpen(false);
    };
    const onPointerDown = (e: PointerEvent) => {
      if (!headerRef.current?.contains(e.target as Node)) setOpen(false);
    };
    document.addEventListener('keydown', onKeyDown);
    document.addEventListener('pointerdown', onPointerDown);
    return () => {
      document.removeEventListener('keydown', onKeyDown);
      document.removeEventListener('pointerdown', onPointerDown);
    };
  }, [open]);

  return (
    <header className="topbar" ref={headerRef}>
      <div className="container inner">
        <Link to="/" className="brand" aria-label={t('common.appName')}>
          <span className="brand-badge">FWR</span>
          <span className="name">{t('common.appName')}</span>
        </Link>
        <div className="spacer" />
        {user ? (
          <>
            <button
              type="button"
              className="btn btn-ghost nav-toggle"
              data-testid="nav-toggle"
              aria-label={t('nav.menu')}
              aria-expanded={open}
              aria-controls="topbar-nav"
              onClick={() => setOpen((v) => !v)}
            >
              <svg width="20" height="20" viewBox="0 0 20 20" aria-hidden="true" focusable="false">
                {open ? (
                  <path d="M4 4l12 12M16 4L4 16" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
                ) : (
                  <path d="M3 5h14M3 10h14M3 15h14" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
                )}
              </svg>
            </button>
            <nav id="topbar-nav" className={`topbar-nav${open ? ' is-open' : ''}`}>
              <Link className="btn btn-ghost btn-sm" to="/">
                {t('nav.directory')}
              </Link>
              <Link className="btn btn-ghost btn-sm" to="/new">
                {t('nav.newRound')}
              </Link>
              {user.isAdmin && (
                <Link className="btn btn-ghost btn-sm" to="/admin">
                  {t('nav.admin')}
                </Link>
              )}
              <Link className="btn btn-ghost btn-sm" to="/konto">
                {t('nav.account')}
              </Link>
              <Link className="btn btn-ghost btn-sm" to="/einstellungen">
                {t('nav.settings')}
              </Link>
              <div className="topbar-nav-foot">
                <LanguageSwitch />
                <button className="btn btn-ghost btn-sm" onClick={() => void logout()}>
                  {t('common.logout')}
                </button>
              </div>
            </nav>
          </>
        ) : (
          <LanguageSwitch />
        )}
      </div>
    </header>
  );
}
